import React, {useMemo, useState} from 'react';
import clsx from 'clsx';
import {useInferableTranslation} from '@di-shared/features/common/useInferableTranslation';
import {TagFormBottomSheetProps, TagFormBottomSheetResult} from '@di-shared/features/history/tags/TagFormBottomSheet/index';

const MAX_TAG_NAME_LENGTH = 20;

export default function TagFormBottomSheetNa({initialTagName = ''}: TagFormBottomSheetProps) {
  const {t} = useInferableTranslation();
  const [tagName, setTagName] = useState(initialTagName);

  const normalizedTagName = useMemo(() => tagName.slice(0, MAX_TAG_NAME_LENGTH), [tagName]);
  const normalizedInitialTagName = useMemo(() => initialTagName.slice(0, MAX_TAG_NAME_LENGTH).trim(), [initialTagName]);
  const isSaveDisabled = normalizedTagName.trim().length === 0 || normalizedTagName.trim() === normalizedInitialTagName;

  function closeWithResult() {
    const result: TagFormBottomSheetResult = {
      tagName: normalizedTagName.trim(),
    };

    window.bottomSheetClose(result);
  }

  return (
    <div className="bottom_sheet">
      <div className="bottom_sheet_header">
        <h2
          id="bottomSheetTitle"
          className="bottom_sheet_title"
        >
          {t('ctn_mytrips_tags_create_title_eu')}
        </h2>
        <button
          type="button"
          className="btn btn_ic"
          aria-label="close"
          onClick={() => window.bottomSheetClose(null)}
        >
          <span
            className="ic ic_close_20px"
            aria-hidden="true"
          ></span>
        </button>
      </div>
      <div className="bottom_sheet_inner">
        <div className="bottom_sheet_contents">
          <div className="tag_enter_area">
            <div className={clsx('input_box input_box_field', {input_focused: true})}>
              <input
                type="text"
                className="input_text body_large_r"
                placeholder={t('msg_mytrips_tags_create_enter_eu')}
                value={normalizedTagName}
                onChange={(event) => setTagName(event.target.value)}
              />
            </div>
            <div className="enter_status">
              <span className="total">
                <strong className="current">{normalizedTagName.length}</strong>/{MAX_TAG_NAME_LENGTH}
              </span>
            </div>
          </div>
        </div>

        <div className="bottom_sheet_footer bottom_sheet_footer_vertical">
          <button
            type="button"
            className="btn btn_large btn_filled"
            disabled={isSaveDisabled}
            onClick={closeWithResult}
          >
            {t('ctn_mytrips_tags_create_save_eu')}
          </button>

          <button
            type="button"
            className="btn btn_large btn_outline"
            onClick={() => window.bottomSheetClose(null)}
          >
            {t('ctn_mytrips_tags_create_cancel_eu')}
          </button>
        </div>
      </div>
    </div>
  );
}
